import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const dashboardStore = defineStore('dashboard', {
  state: () => ({
    loading: {
      transactions: false
    },
    filterParams: {
      firm: null,
      startdate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0],
      enddate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString().split('T')[0],
      orderBy: 'createdOn',
      sortBy: 'desc',
      type: null
    },
    transactions: null,
    reviewTypes: [
      {
        id: 0,
        name: 'Total Count',
        value: 'totalcount'
      },
      {
        id: 1,
        name: 'Totals over Time',
        value: 'totalcountOverTime'
      },
      {
        id: 2,
        name: 'Totals (by Location)',
        value: 'totals'
      },
      {
        id: 3,
        name: 'Totals (by Vendor)',
        value: 'totalsByVendor'
      },
      {
        id: 4,
        name: 'Totals (by Vendor) over Time',
        value: 'totalsByVendorOverTime'
      },
      {
        id: 5,
        name: 'Transactions',
        value: 'invoiceTransactions'
      },
      {
        id: 6,
        name: 'Invoices',
        value: 'invoices'
      }
    ]
  }),
  actions: {
    resetTransactions() {
      this.transactions = null
    },
    setFilter(data) {
      this.filterParams[data.name] = data.value
    },
    resetFilter() {
      this.filterParams = {
        firm: null,
        startdate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0],
        enddate: new Date(new Date().setHours(23, 59, 59, 999)).toISOString().split('T')[0],
        orderBy: 'createdOn',
        sortBy: 'desc',
        type: null
      }
    },
    async getTransactions(data) {
      this.loading.transactions = true
      this.transactions = []
      let results = await api.get(
        `dashboard/transactions?firm=${data.firm}&startdate=${data.startdate}&enddate=${data.enddate}&orderBy=${data.orderBy}&sortBy=${data.sortBy}&type=${data.type}`
      )
      this.loading.transactions = false
      if (results) {
        if (results !== '') {
          this.transactions = results
        }
      }
      console.log('Got Transactions', this.transactions)
      return results
    },
    async getTransactionReport(data) {
      return api.get(
        `report/transactionsReport?firm=${data.firm}&startdate=${data.startdate}&enddate=${data.enddate}&orderBy=${data.orderBy}&sortBy=${data.sortBy}&asBase64=true`
      )
    }
  }
})
